import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const Pagination = ({
  meta,
  onLoadMore,
  isLoading,
  className,
  style,
  text = {
    loadButton: "Load more"
  },
  ...props
}) => /* @__PURE__ */ React.createElement("div", { ...props, style, className: cx(styles.box, className) }, /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement("div", { className: styles.info }, /* @__PURE__ */ React.createElement("div", { className: styles.pages }, meta.current_page, " / ", meta.last_page), /* @__PURE__ */ React.createElement(
  "div",
  {
    className: styles.progress,
    style: {
      "--percent": `${meta.current_page / (meta.last_page / 100 || 1)}%`
    }
  }
), /* @__PURE__ */ React.createElement("div", { className: styles["progress-value"] }, Math.floor(meta.current_page / (meta.last_page / 100 || 1)), " %")), /* @__PURE__ */ React.createElement(
  "button",
  {
    className: styles.btn,
    disabled: meta.current_page === meta.last_page || isLoading,
    type: "button",
    onClick: onLoadMore
  },
  text.loadButton
)));
Pagination.displayName = "Pagination";

export { Pagination };
//# sourceMappingURL=index.js.map
